<my-global-navigation></my-global-navigation>
<div toastContainer class="toast-container-center"></div>
<div class="container-fluid">
    <div class="main-container" (click)="doNothing()">
        <router-outlet></router-outlet>
    </div>
</div>


<!-- Error Modal -->
<div class="modal fade" bsModal #errorModal="bs-modal"
     tabindex="-1" role="dialog" aria-hidden="true" id="errorModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" style="width: inherit">
            <div class="modal-header" style="background-color: darkred !important; justify-content: space-between;">
                <h4 class="modal-title pull-xs-left">{{errorTitle}}</h4>
                <button type="button" class="close" aria-label="Close" (click)="closeError()" style="background-color: darkred">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <p *ngFor="let message of errorMessages" style="word-break: break-all">{{message}}</p>
            </div>
            <div class="modal-footer">
                <div class="col-12 text-align-right">
                    <button class="btn btn-primary" (click)="closeError()">Ok</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Forbidden Modal -->
<div class="modal fade" bsModal #forbiddenModal="bs-modal" id="forbiddenModal"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" style="width: inherit">
            <div class="modal-header" style="justify-content: space-between;">
                <h4 class="modal-title pull-xs-left">Access to Resource Denied</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeForbidden()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                You do not have access to this resource.
            </div>
            <div class="modal-footer">
                <div class="col-12 text-align-right">
                    <button class="btn btn-primary" (click)="closeForbidden()">Ok</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Idle Warning Modal -->
<div class="modal fade" bsModal #idleModal="bs-modal" id="idleModal"
     (onHidden)="onIdleWarningHide()"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content" style="width: inherit">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">
                    You have been inactive for a while...
                </h4>
            </div>
            <div class="modal-body">
                <p>
                    Do you want to continue or log out?
                </p>
                <progressbar type="warning" [max]="autoLogoutPeriod" [value]="autoLogoutRemaining">Automatic log out...</progressbar>
            </div>
            <div class="modal-footer">
                <div class="col-6 text-align-left">
                    <button class="btn btn-warning" (click)="relogin()">Log Out Now</button>
                </div>
                <div class="col-6 text-align-right">
                    <button class="btn btn-secondary" (click)="HideIdleModal()">Continue</button>
                </div>
            </div>
        </div>
    </div>
</div>
